import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const GoogleDevice916: FC<Props> = (props) => (
  <Root viewBox="0 0 145.783 300.88" {...props}>
    <g data-name="\u30B0\u30EB\u30FC\u30D7 316" transform="translate(-354.657 -156.533)">
      <rect
        data-name="\u9577\u65B9\u5F62 745"
        width={145.783}
        height={300.88}
        rx={21.724}
        transform="translate(354.657 156.533)"
      />
      <path data-name="\u9577\u65B9\u5F62 746" fill="#fff" d="M360.937 196.186h132.072v21.956H360.937z" />
      <g data-name="\u30B0\u30EB\u30FC\u30D7 315">
        <path
          data-name="\u30D1\u30B9 1021"
          d="M492.928 196.186v-18.01a14.308 14.308 0 00-14.308-14.309H464.5v1.918a7.586 7.586 0 01-7.586 7.586h-59.12a7.586 7.586 0 01-7.586-7.586v-1.918h-14.962a14.309 14.309 0 00-14.309 14.309v18.01z"
          fill="#f2f2f2"
        />
      </g>
      <rect
        data-name="\u9577\u65B9\u5F62 747"
        width={116.48}
        height={11.384}
        rx={5.692}
        transform="translate(366.971 179.958)"
        fill="#e7e7e7"
      />
      <path
        data-name="\u30D1\u30B9 1022"
        d="M360.937 290.137v145.635a14.309 14.309 0 0014.309 14.309H478.62a14.308 14.308 0 0014.308-14.309V290.137z"
        fill="#fff"
      />
      <rect
        data-name="\u9577\u65B9\u5F62 748"
        width={34.733}
        height={3.524}
        rx={1.762}
        transform="translate(408.363 442.557)"
      />
      <path data-name="\u9577\u65B9\u5F62 749" fill="#424242" d="M493.276 197.96v239.09h-132.51V197.96z" />
    </g>
  </Root>
);

const Root = styled('svg')();

export default GoogleDevice916;
